export const environment = {
  production: true,
  version: "1.1.1",
  title: "Rezervační portál",
  apiUrl: '/api/public/',
  clientBase: '/',
  currency: "Kč",
  modulesWOutRights: [],
  loginOpts: {
    pass: { collapsed: false }
  },
  firebase: null,
  controlWifi: false,
  headerMessages: false,
  multiApp: false,
  appPaths: null,
  dbEditByRight: false,
  hideScannerManualInput: false,
  isEml: false,
  isRep: true
}
